import create from "zustand"

const useProfileStore = create((set) => ({
  membershipNumber: "",
  setMembershipNumber: (number) => set({ membershipNumber: number }),
  fullName: "",
  setFullName: (fullName) => set({ fullName }),
  birthDay: "",
  setBirthDay: (birthDay) => set({ birthDay }),
  birthMonth: "",
  setBirthMonth: (birthMonth) => set({ birthMonth }),
  birthYear: "",
  setBirthYear: (birthYear) => set({ birthYear }),
  gender: "",
  setGender: (gender) => set({ gender }),
  street: "",
  setStreet: (street) => set({ street }),
  postalCode: "",
  setPostalCode: (postalCode) => set({ postalCode }),
  city: "",
  setCity: (city) => set({ city }),
  email: "",
  setEmail: (email) => set({ email }),
  oldEmail: "",
  setOldEmail: (oldEmail) => set({ oldEmail }),
  mobileNumber: "",
  setMobileNumber: (mobileNumber) => set({ mobileNumber }),
  country: "",
  setCountry: (country) => set({ country }),
  countryCode: "",
  setCountryCode: (countryCode) => set({ countryCode }),
  acceptedNewsletterConsentVersion: "",
  setAcceptedNewsletterConsentVersion: (version) => set({ acceptedNewsletterConsentVersion: version }),
  acceptedParkingServicesConsentVersion: "",
  setAcceptedParkingServicesConsentVersion: (version) => set({ acceptedParkingServicesConsentVersion: version }),
  currentPassword: "",
  setCurrentPassword: (password) => set({ currentPassword: password }),
  newPassword: "",
  setNewPassword: (password) => set({ newPassword: password }),
  repeatedNewPassword: "",
  setRepeatedNewPassword: (password) => set({ repeatedNewPassword: password }),
  vehicleRegistrationNumber: "",
  setVehicleRegistrationNumber: (number) => set({ vehicleRegistrationNumber: number }),
  vehicleMake: "",
  setVehicleMake: (make) => set({ vehicleMake: make }),
  vehicleModel: "",
  setVehicleModel: (model) => set({ vehicleModel: model }),
  vehicleColour: "",
  setVehicleColour: (colour) => set({ vehicleColour: colour }),
  contactPermissionIsChecked: false,
  setContactPermissionIsChecked: (isChecked) => set({ contactPermissionIsChecked: isChecked }),
  contactPermissionVersion: "",
  setContactPermissionVersion: (version) => set({ contactPermissionVersion: version }),
  parkingContactPermissionIsChecked: false,
  setParkingContactPermissionIsChecked: (isChecked) => set({ parkingContactPermissionIsChecked: isChecked }),
  parkingContactPermissionVersion: "",
  setParkingContactPermissionVersion: (version) => set({ parkingContactPermissionVersion: version }),
  isFullNameValid: false,
  setIsFullNameValid: (isValid) => set({ isFullNameValid: isValid }),
  isEmailValid: false,
  setIsEmailValid: (isValid) => set({ isEmailValid: isValid }),
  isMobileValid: false,
  setIsMobileValid: (isValid) => set({ isMobileValid: isValid }),
  isCountryValid: false,
  setIsCountryValid: (isValid) => set({ isCountryValid: isValid }),
  mobileErrorMessage: undefined,
  setMobileErrorMessage: (message) => set({ mobileErrorMessage: message }),
  showUpdatedProfileMessage: false,
  setShowUpdatedProfileMessage: (show) => set({ showUpdatedProfileMessage: show }),
  updatedProfileMessage: "Profil opdateret!",
  setUpdatedProfileMessage: (message) => set({ updatedProfileMessage: message }),
  passwordValidationMessage: undefined,
  setPasswordValidationMessage: (message) => set({ passwordValidationMessage: message }),
  yearsArray: [],
  setYearsArray: (years) => set({ yearsArray: years }),
  monthsArray: [],
  setMonthsArray: (months) => set({ monthsArray: months }),
  daysArray: [],
  setDaysArray: (days) => set({ daysArray: days }),
  gendersArray: [],
  setGendersArray: (genders) => set({ gendersArray: genders }),
  countriesArray: [],
  setCountriesArray: (countries) => set({ countriesArray: countries }),
  isPasswordModalOpen: false,
  setIsPasswordModalOpen: (isOpen) => set({ isPasswordModalOpen: isOpen }),
  ajaxSpinnerActive: false,
  setAjaxSpinnerActive: (isActive) => set({ ajaxSpinnerActive: isActive }),
  loadingLicensePlate: false,
  setLoadingLicensePlate: (isLoading) => set({ loadingLicensePlate: isLoading }),
}))

export default useProfileStore
